import { EnvironmentProviders, inject, Injectable, provideAppInitializer } from '@angular/core';
import { AppConfig } from '~app/types/app-config';
import { ApiConfiguration } from '~generated-api/api-configuration';

@Injectable({
  providedIn: 'root',
})
export class ConfigService implements AppConfig {

  public BASE_URL = '';
  public COMMIT = '';
  public VERSION = '';
  public API_KEY = '';
  public SENTRY_ENVIRONMENT = '';
  public ENV_LABEL?: string;
  public GOOGLE_CLIENT_ID?: string;

  public static factory(config: AppConfig): (configService: ConfigService, apiConfiguration: ApiConfiguration) => () => void {
    return (configService: ConfigService, apiConfiguration: ApiConfiguration) => {
      configService.loadConfig(config);
      apiConfiguration.rootUrl = config.BASE_URL;
      return () => {
        // Finished loading configs
      };
    };
  }

  public static provide(config: AppConfig): EnvironmentProviders {
    return provideAppInitializer(() => {
      const initializerFn = (ConfigService.factory(config))(inject(ConfigService), inject(ApiConfiguration));
      return initializerFn();
    });
  }

  public loadConfig(config: AppConfig) {
    this.BASE_URL = config.BASE_URL;
    this.COMMIT = config.COMMIT;
    this.VERSION = config.VERSION;
    this.API_KEY = config.API_KEY;
    this.SENTRY_ENVIRONMENT = config.SENTRY_ENVIRONMENT;
    this.ENV_LABEL = config.ENV_LABEL;
    this.GOOGLE_CLIENT_ID = config.GOOGLE_CLIENT_ID;
  }


}
